export function columnTheme() {
  return {
    '&:nth-child(0)': {
      width: '20px',
    },
    '&:nth-child(1)': {
      width: '20px',
      paddingLeft: '10px',
    },
    '&:nth-child(2)': {
      paddingLeft: '10px',
      minWidth: '100px',
      maxWidth: '150px',
      width: '150px',
    },
    '&:nth-child(3)': {
      maxWidth: '100px',
      minWidth: '100px',
      width: '100px',
    },
    '&:nth-child(4)': {
      width: '75px',
      maxWidth: '75px',
      minWidth: '75px',
    },
    '&:nth-child(5)': {
      maxWidth: '100px',
      minWidth: '100px',
      width: '100px',
    },
    '&:nth-child(6)': {
      maxWidth: '100px',
      minWidth: '100px',
      width: '100px',
    },
    '&:nth-child(7)': {
      width: '75px',
      maxWidth: '75px',
      minWidth: '75px',
    },
    '&:nth-child(8)': {
      width: '75px',
      maxWidth: '75px',
      minWidth: '75px',
    },
    '&:nth-child(9)': {
      width: '75px',
      maxWidth: '75px',
      minWidth: '75px',
    },
    '&:nth-child(10)': {
      width: '520px',
      minWidth: '200px',
    },
    '&:nth-child(11)': {
      width: '50px',
    },
  }
}
